<template>
    <div id="courses" class="offset">
        <div class="col-md-12 narrow text-center">
            <h1>PRIMA FOGÁSZATI ÉS FOGSZABÁLYOZÁSI RENDELŐ</h1>
            <br>
            <p class="lead">
Tapasztalt, magas szinten képzett fogorvos csapatunk várja fogászati rendelőnkben Szegeden, a liget szomszédságában. Fogorvosi rendelőnk teljeskörő fogászati ellátást kínál: általános és esztétikai fogászati kezelések mellett fogszabályozás és szájsebészeti beavatkozások (fogbeültetés, bölcsességfog eltávolítás) terén is. A fogorvosi kezeléseket kizárólag prémium fogászati anyagok felhasználásával, a lehető legmodernebb fogorvosi eszközökkel végezzük. Fogorvosi rendelőnk csapatának minden tagjára igaz, hogy számunkra a fogorvosi ellátás biztosítása nem csupán egy munka, hanem hivatás is. Célunk, hogy minden páciensünk elégedetten, magabiztos mosollyal távozzon tőlünk. Egy Fogászat Szegeden, ahol problémáját gyorsan, fájdalommentesen és magas szakmai színvonalon orvosolják.</p>
            <a href="#contact" target="_blank" class="btn btn-secondary btn-md">Vizsgálatra jeletkezem</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "courses"
};
</script>
